export const presetLabels = {
  BBQ_BIAS: 'BBQ biased',
  BBQ_UNBIAS: 'BBQ unbiased',
  UNQOVER_BIAS: 'UNQOVER biased',
  HALU_EVAL: 'HaluEval',
  MED_HALLU: 'MedHallu',
  INJECTION_EVAL: 'Prompt injection: Purple Llama',
  XSTEST: 'Refusal: XSTest',
  OR_BENCH: 'Refusal: ORBench',
} as const

export type PresetKey = keyof typeof presetLabels
